module.exports = __webpack_public_path__ + "images/cashOnDelivery-1V-Js9K.svg";